// Efeito de visualização "Tudo do plano X, mais:" nos cards de plano (landing e /plans).
// Regra: o plano-base é o plano de menor preço imediatamente anterior na lista carregada
// (desempate por nome), considerando só planos do mesmo segmento ou genéricos (sem segmento).
// Se o plano tem todos os módulos do base (por `key` em module_details), o card lista só os
// módulos extras; se tem menos módulos que o base, ou não há anterior, lista tudo.
// Puro e só no cliente: não altera o contrato da API.

import { planDisplayName } from './planDisplayName';

const planCents = (plan) => (Number(plan.value_reais) || 0) * 100 + (Number(plan.value_cents) || 0);

const byPriceThenName = (a, b) => (
  planCents(a) - planCents(b) || String(a.name).localeCompare(String(b.name), 'pt-BR')
);

const sameTierGroup = (a, b) => !a.segment || !b.segment || a.segment === b.segment;

const modulesOf = (plan) => (Array.isArray(plan.module_details) ? plan.module_details : []);

/**
 * Devolve um mapa plan.id -> { baseName, modules }.
 * baseName = nome do plano-base ou null; modules = módulos a listar no card.
 */
export function buildPlanTiers(plans) {
  const list = Array.isArray(plans) ? plans : [];
  const sorted = [...list].sort(byPriceThenName);
  const tiers = new Map();

  sorted.forEach((plan, index) => {
    const modules = modulesOf(plan);
    let base = null;
    for (let i = index - 1; i >= 0; i -= 1) {
      if (sameTierGroup(sorted[i], plan)) {
        base = sorted[i];
        break;
      }
    }

    if (base) {
      const planKeys = new Set(modules.map((m) => m.key));
      const baseKeys = modulesOf(base).map((m) => m.key);
      if (baseKeys.every((key) => planKeys.has(key))) {
        const baseKeySet = new Set(baseKeys);
        tiers.set(plan.id, {
          baseName: base.name,
          modules: modules.filter((m) => !baseKeySet.has(m.key)),
        });
        return;
      }
    }
    tiers.set(plan.id, { baseName: null, modules });
  });

  return tiers;
}

// Texto da linha de destaque; sem módulos extras não leva o "mais:".
export const tierHeadline = (tier) => (
  `Tudo do plano ${planDisplayName(tier.baseName)}${tier.modules.length > 0 ? ', mais:' : ''}`
);
